import { render } from "./PrivacyUser.vue?vue&type=template&id=5c0bbe22&scoped=true"
import script from "./PrivacyUser.vue?vue&type=script&lang=js"
export * from "./PrivacyUser.vue?vue&type=script&lang=js"

import "./PrivacyUser.vue?vue&type=style&index=0&id=5c0bbe22&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0bbe22"]])

export default __exports__